export const removeMinorAttributes = (item) => ({
    ...item,
    brand: '',
    brandModel: '',
    linkedProductionMethods: [],
});
